export default "__VITE_ASSET__ff439c97__"